<template>
<div class="chapter">
<div class="inner_page">
<div class="dedi-side">
<p class="dedication"><em class="italic">For W, who adds the word ’maximus’ to the end of every flower to pretend he knows its Latin name. And to Sebastianus Oleanderus, my favourite little plant</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02a_Dedication.vue?1b7ed7a3